import React, { useState } from "react";
import { Button, Dropdown, DropdownButton, Form, Modal } from "react-bootstrap";
import Spin from "../../common/Spin";
import moment from "moment";
import { DatePicker } from "rsuite";
// import Spin from "../../common/Spin";

const GenerateAbaApprovalModal = (props) => {
  const {
    showModal,
    handleModalClose,
    handleSubmit,
    loading,
    // toggleGenerateModal,
    // generateModal,
    selectedRowIds,
  } = props;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [fileNote, setFileNote] = useState("");
  const [abaGenerateDate, setAbaGenerateDate] = useState(today);
  return (
    <>
      <Modal
        size="lg"
        show={showModal}
        onHide={() => {
          handleModalClose();
          setFileNote("");
        }}
        dialogClassName="modal-50w small-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        className="project-section"
        centered
      >
        <Modal.Header closeButton>Note</Modal.Header>
        <Modal.Body>
          {loading && <Spin />}
          {selectedRowIds?.length > 1 && (
            <div className="paymentNote" style={{ marginBottom: "10px" }}>
              <p className="aba-transaction-date-label">
                <span className="required">*</span>Transaction Date
                <div className="apca-info">
                  <DropdownButton className="info-icon" title="">
                    <Dropdown.Item>
                      <p>
                        Select the date on which date you want to make payment
                        or you already made the payment.
                      </p>
                    </Dropdown.Item>
                  </DropdownButton>
                </div>
              </p>
              <DatePicker
                cleanable={false}
                onChange={(e) => {
                  setAbaGenerateDate(moment(e, "DD-MM-YYYY"));
                  // let date = moment(e)?._d;
                  // setPreviousDate(date);
                }}
                format="dd-MM-yyyy"
                value={
                  abaGenerateDate
                    ? String(abaGenerateDate)?.includes("-")
                      ? new Date(
                          String(abaGenerateDate)?.split("-")[2],
                          String(abaGenerateDate)?.split("-")[1] - 1,
                          String(abaGenerateDate)?.split("-")[0]
                        )
                      : new Date(abaGenerateDate)
                    : null
                }
                className="rs-date-body"
                placeholder="Select Date"
                placement="autoVerticalStart"
                style={{
                  width: "162px",
                }}
                disabledDate={(date) => moment(date).isAfter(moment())}
              />
            </div>
          )}
          <div className="paymentNote" style={{ marginBottom: "10px" }}>
            <p>
              <span className="required">*</span>Payment Note
            </p>
            <Form.Control
              type="text"
              className="left-text-align"
              required
              maxLength={150}
              value={fileNote ? fileNote : ""}
              rules={[
                {
                  pattern: new RegExp(/^[^!@#)(^%$<>][a-zA-Z\s\d.,/&-]*$/),
                  message:
                    "Note can contain letters, numbers, ampersand(&), dot(.), comma(,), hyphon(-), slash(/) & spaces.",
                },
              ]}
              onChange={(e) => {
                setFileNote(e.target.value);
              }}
            ></Form.Control>
          </div>
          <div className="modal-footer">
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => handleSubmit(0, fileNote, abaGenerateDate)}
              disabled={!fileNote}
            >
              Post
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {/* <Modal
        size="lg"
        show={generateModal}
        onHide={toggleGenerateModal}
        dialogClassName="modal-50w small-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        className="project-section"
        centered
      >
        <Modal.Header closeButton>Send Email Confirmation!</Modal.Header>
        <Modal.Body>
          {loading && <Spin />}
          <div
            className="content-details"
            style={{ paddingBottom: "10px", paddingTop: "10px" }}
          >
            <p>Do you want to send receipt via email to client(s)?</p>
          </div>
          <div className="modal-footer">
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => handleSubmit(1, fileNote)}
              disabled={!fileNote}
            >
              Yes
            </Button>
            <Button
              type="Button"
              className="btn btn-secondary"
              onClick={() => handleSubmit(0, fileNote)}
              disabled={!fileNote}
            >
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default GenerateAbaApprovalModal;
